import { render, staticRenderFns } from "./coffee-page-controls.vue?vue&type=template&id=f462cd9c&"
import script from "./coffee-page-controls.vue?vue&type=script&lang=js&"
export * from "./coffee-page-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports